import { loadBlocklyState } from '@/utils/blockly/fe-blockly-web'
import '@/utils/blockly/style.css'
export default defineNuxtPlugin((_nuxtApp) => {
  return {
    provide: {
      blockly: loadBlocklyState
    }
  }
})
